import React from 'react';
import { Button, Space, Tooltip } from 'antd';
import { Pause, Play, SkipBack, SkipForward } from 'lucide-react';
import { colors, dimensions } from '../../../theme';

type TransportControlsProps = {
  isPlaying: boolean;
  playDisabled?: boolean;
  onPlay: () => void;
  onPause: () => void;
  onRewind: () => void;
  onForward: () => void;
};

export const TransportControls: React.FC<TransportControlsProps> = ({
  isPlaying,
  playDisabled = false,
  onPlay,
  onPause,
  onRewind,
  onForward
}) => (
  <Space size={dimensions.spacing.sm} align='center'>
    <Tooltip title='Retroceder'>
      <Button
        type='text'
        shape='circle'
        size='small'
        icon={<SkipBack size={dimensions.size.iconSm} fill='currentColor' />}
        onClick={onRewind}
        style={{ color: colors.accent }}
      />
    </Tooltip>
    <Tooltip title={playDisabled ? 'Cargando medios…' : isPlaying ? 'Pausar' : 'Reproducir'}>
      <Button
        type='primary'
        shape='circle'
        disabled={playDisabled}
        icon={
          isPlaying ? (
            <Pause size={dimensions.size.iconSm} fill='currentColor' />
          ) : (
            <Play size={dimensions.size.iconSm} fill='currentColor' />
          )
        }
        onClick={isPlaying ? onPause : onPlay}
        style={{ backgroundColor: colors.accent, borderColor: colors.accent }}
      />
    </Tooltip>
    <Tooltip title='Avanzar'>
      <Button
        type='text'
        shape='circle'
        size='small'
        icon={<SkipForward size={dimensions.size.iconSm} fill='currentColor' />}
        onClick={onForward}
        style={{ color: colors.accent }}
      />
    </Tooltip>
  </Space>
);
